import "./ClientConsentReading.css";
import { createPortal } from 'react-dom';
import { Home, CalendarDays, CalendarPlus, Images } from 'lucide-react';
import { tr } from '@/i18n/copy';
import { useUiLanguage } from '@/i18n/useUiLanguage';
import { clientVisualStyleClass, studioBrandStyle } from '@/studioBranding';

const sections = [
  {id: 'home', label: 'Home', Icon: Home},
  {id: 'appointments', label: 'Appuntamenti', Icon: CalendarDays},
  {id: 'services', label: 'Prenota', Icon: CalendarPlus},
  {id: 'history', label: 'I miei tattoo', Icon: Images},
];

export default function ClientNavigationFrame({ studio, view, onNavigate, children }) {
  useUiLanguage();
  const active = ['services', 'booking', 'walkin'].includes(view) ? 'services' : view;
  const navigate = id => {
    // A child with an unsaved form can prevent the section change without
    // hiding the app navigation or bypassing its normal save/finalize path.
    const event = new CustomEvent('tps:client-navigate', {cancelable: true, detail: {view: id}});
    if (window.dispatchEvent(event)) onNavigate(id);
  };
  return <>
    <div className="client-navigation-content">{children}</div>
    {createPortal(<div className={`client-navigation-layer client-branded-shell ${view === "consents" ? "client-consent-reading" : ""} ${clientVisualStyleClass(studio)}`} style={studioBrandStyle(studio)}>
      <nav aria-label={tr('Navigazione cliente')} className="client-bottom-navigation grid grid-cols-4 gap-1 rounded-2xl border border-white/10 bg-card/95 p-2 shadow-2xl backdrop-blur-xl" data-testid="client-bottom-navigation">
        {sections.map(({id, label, Icon}) => <button key={id} type="button" onClick={() => navigate(id)} aria-current={active === id ? 'page' : undefined}
          className="client-navigation-item flex min-h-14 flex-col items-center justify-center gap-1 rounded-xl px-1 text-[10px] font-medium text-muted-foreground focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2">
          <Icon aria-hidden="true" className={`h-5 w-5 ${active === id ? 'text-[#E10600]' : ''}`} />
          <span className="truncate">{tr(label)}</span>
        </button>)}
      </nav>
    </div>, document.body)}
  </>;
}
